import {FC, useState} from "react";
import {Card, Table} from "react-bootstrap";
import useRecommendedActions from "@oldDashboard/legacyHooks/useRecommendedActions";
import Loader from "@/components/common/loader/loader";
import { RecommendedAction } from "@oldDashboard/legacyModels/recommendedAction.model";

interface RecomendedActionsProps { recommendedActions: RecommendedAction, affiliateSelected: String, launchSelected: String, timePeriodSelected: String , searching: boolean}
const RecomendedActionsTile: FC<RecomendedActionsProps> = ({recommendedActions, affiliateSelected, launchSelected, timePeriodSelected, searching }) => {
    const [sort, setSort] = useState("status");
    const { isLoading, fetchUseRecommended } = useRecommendedActions({affiliateSelected, launchSelected, timePeriodSelected, sort, searching});
    
    const filterTable = (filter: string) => {
        setSort(filter);
        fetchUseRecommended(filter);
    }
    if (recommendedActions.data.length == 0) return null;
    return (
        <Card className="custom-card overflow-hidden" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Header className="justify-content-between overflow-auto">
                <Card.Title>
                    Recommended Actions
                </Card.Title>
            </Card.Header>
            <Card.Body className="p-0 overflow-hidden">
                <div className="table-responsive overflow-scroll" style={{height:"190px"}}>
                    <Table className="table text-nowrap" style={{tableLayout:"fixed"}}>
                        <thead>
                            <tr>
                            {
                                recommendedActions.header.map((item, index) => 
                                    <th className="position-sticky fixed-top cursor-pointer"scope="col" key={index} onClick={()=>{filterTable(item.caption.toLocaleLowerCase())}}>
                                        {item.caption} { sort == item.caption.toLocaleLowerCase() && <i className="bi bi-sort-up fs-14"></i>}
                                    </th>
                            )}
                            </tr>
                        </thead>
                        <tbody>
                             {
                                recommendedActions.data.map((item, index) => 
                                    <tr key={index}>
                                        {
                                            <>
                                            <td  className="text-wrap">{item[0]}</td>
                                            <td className="text-wrap"><div>{item[1]}</div></td>
                                            </>
                                        }
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default RecomendedActionsTile;
